<div class="card">
    <div class="card-header">
        <div class="d-flex justify-content-between">
            <h4 class="text-dark">{{ words[language][ 'addresses' ] }}</h4>
            <button class="btn btn-primary" type="button" (click)="append(null)" aria-expanded="false">
                <span class="uil-plus"></span>
            </button>
        </div>
        <div class="card-body">
            <form [formGroup]="form">
                <datalist id="zip-codes">
                    @for (zip of zipCodeList; track zip) {
                    <option (click)="zipSelected(zip)" [value]="zip.zipcode"></option>
                    }
                </datalist>

                <ng-container formArrayName="addresses">
                    <div class="card-deck">
                        @for (addyForm of addresses.controls; track addyForm; let i = $index) {
                        <div class="card ribbon-box addy" [formGroup]="addyForm">
                            @if (addyForm.get('primary').value == 1) {
                            <div class="ribbon-two ribbon-two-primary">
                                <span>{{ words[language][ 'default' ] }}</span>
                            </div>
                            }
                            <div class="card-body">
                                @if (!addyForm.get('editing').value) {
                                <section>
                                    <p>{{addyForm.get('address').value}} {{addyForm.get('address2').value}}</p>
                                    <p>{{addyForm.get('city').value}}, {{addyForm.get('state').value}}
                                        {{addyForm.get('zipCode').value}}</p>
                                </section>
                                }
                                @if (addyForm.get('editing').value) {
                                <section>
                                    <div class="form-row">
                                        <div class="form-group col">
                                            <input type="text" class="form-control form-control-sm"
                                                formControlName="address" placeholder="Street Address" />
                                        </div>
                                        <div class="form-group col-3">
                                            <input type="text" class="form-control form-control-sm"
                                                formControlName="address2" placeholder="Addenda" />
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col">
                                            <input type="text" class="form-control form-control-sm"
                                                formControlName="city" placeholder="City" tabindex="-1" readonly />
                                        </div>
                                        <div class="form-group col-2">
                                            <input type="text" class="form-control form-control-sm"
                                                formControlName="state" placeholder="State" tabindex="-1" readonly />
                                        </div>
                                        <div class="form-group col-4">
                                            <input type="search" class="form-control form-control-sm"
                                                formControlName="zipCode" placeholder="Zip Code" (keyup)="inquired(i)"
                                                list="zip-codes" autocomplete="off" />
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col">
                                            <select class="custom-select custom-select-sm" formControlName="status">
                                                @for (status of rentOwn; track status) {
                                                <option [value]="status">{{status}}</option>
                                                }
                                            </select>
                                        </div>
                                        <div class="form-group col">
                                            <select class="custom-select custom-select-sm"
                                                formControlName="addressTypeId">
                                                @for (type of types; track type) {
                                                <option [value]="type.id">{{ words[language][type.type.toLowerCase()] }}
                                                </option>
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </section>
                                }
                            </div>
                            <div class="card-footer">
                                @if (addyForm.get('editing').value) {
                                <button type="button" class="btn btn-sm btn-link text-danger"
                                    (click)="discard($event, i)"><span class="dripicons-trash"></span></button>
                                }
                                @if (addyForm.get('editing').value) {
                                <button type="button" class="btn btn-sm btn-primary" [disabled]="addyForm.invalid"
                                    (click)="save($event, i)">Save and Use</button>
                                }
                                @if (addyForm.get('id').value > 0) {
                                <button type="button" class="btn btn-sm btn-primary"
                                    [disabled]="addyForm.get('id').value == addressIdInUse"
                                    (click)="use($event, i)">Use</button>
                                }
                            </div>
                        </div>
                        }
                    </div>
                </ng-container>
            </form>
        </div>
    </div>